// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f427ddf5","239":"1ddab658","455":"1124b9ff"}[chunkId] + ".chunk.js";
};